/**
 *  Stores 
 */
export  const appSetting = {
    localStorage: {
        lang : "comprodls.nemo.selected-locale",
        cookiesAccepted : "comprodls.nemo.cookiesAccepted",
        userLoggedOut: "comprodls.nemo.userLoggedOut",
        adminSelectedView: "comprodls.nemo.admin.selectedView-user.", // To navigate to teacher dashboard or admin dashboard in case of admin (value "teacher/admin")
        foc:"comprodls.nemo.foc",
        userLastActivityTimestamp: "comprodls.nemo.userLastActivityTimestamp",
        userPreferences : (userid) => "comprodls.nemo.user." + userid+ ".preferences",
		tipsPreferences : (userId => "comprodls.nemo.user." + userId+ ".tipsPreference"),
        loggedInUserRole: "comprodls.nemo.loggedInUserRole",
        dashboard: (userid: string) =>
        'comprodls.nemo.user.' + userid + '.dashboard',
        activityEvents: (userid: string) => 'comprodls.nemo.user.' + userid + '.activityEvents'
    },
    sessionStorage: {
        userAccount : "comprodls.nemo.userAccount"
    }
}